import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** 完整取代物料序號關聯。payload 含 snMappingIds 與關聯 GET 的 updatedAt。 */
export async function replaceMtrSnMappings(id, payload) {
  const { data: raw } = await request.put(
    `/mtr/${id}/sn-mappings`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
